/**
 * Shared client-side schedule visibility check.
 *
 * Scans elements carrying [data-schedule-start] / [data-schedule-end] and
 * toggles the `hidden` attribute based on whether "now" falls within that
 * window. Dates are treated as fixed EDT (UTC-4), matching the server-side
 * check in snippets/schedule-visibility.liquid — both sides always agree,
 * no daylight-saving adjustment either way.
 *
 * Elements marked data-editor="true" (only set by Liquid when
 * request.design_mode is true) are never hidden, so merchants can keep
 * editing scheduled content in the theme editor; they get an
 * `is-schedule-inactive` class instead so the editor state is visible.
 */
(function () {
  'use strict';

  function edtToMs(dateStr) {
    if (!dateStr) return null;
    var value = dateStr.trim();
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value)) {
      value += '-04:00';
    }
    var ms = new Date(value).getTime();
    return isNaN(ms) ? null : ms;
  }

  function isWithinWindow(startStr, endStr, nowMs) {
    var startMs = edtToMs(startStr);
    if (startMs !== null && nowMs < startMs) return false;

    var endMs = edtToMs(endStr);
    if (endMs !== null && nowMs > endMs) return false;

    return true;
  }

  function evaluate() {
    var nowMs = Date.now();
    var elements = document.querySelectorAll('[data-schedule-start], [data-schedule-end]');

    elements.forEach(function (element) {
      var startStr = element.getAttribute('data-schedule-start');
      var endStr = element.getAttribute('data-schedule-end');
      var isEditor = element.getAttribute('data-editor') === 'true';
      var visible = isWithinWindow(startStr, endStr, nowMs);

      if (isEditor) {
        element.hidden = false;
        element.classList.toggle('is-schedule-inactive', !visible);
      } else {
        element.hidden = !visible;
        element.classList.remove('is-schedule-inactive');
      }

      element.dispatchEvent(new CustomEvent('schedule:visibility-change', {
        bubbles: true,
        detail: { visible: visible }
      }));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', evaluate);
  } else {
    evaluate();
  }

  setInterval(evaluate, 60000);

  window.ScheduleVisibility = { isWithinWindow: isWithinWindow, edtToMs: edtToMs, evaluate: evaluate };
})();
